const Main = () => import('./Main')

const route = {
  path: '/calendar',
  name: '_calendar',
  meta: {
    title: 'Home (DEMO) - A D M A N 2 0 1 9'
  },
  component: Main
}

export default route
